import { Row, Col } from '@everlywell/leaves';
import SectionWrapper from 'components/SectionWrapper';
import React from 'react';
import { sanitize } from 'utils/helpers';

import * as S from './styles';
export interface IInquirySection {
  headline: string;
  description: string;
  backgroundColor?: string;
  slug?: string;
}

export const InquirySection: React.FC<IInquirySection> = ({
  headline,
  description,
  backgroundColor,
  slug,
}: IInquirySection) => (
  <SectionWrapper
    data-testid={slug || 'inquirySection'}
    id={slug}
    backgroundColor={backgroundColor}
  >
    <S.Container>
      <Row>
        <Col xs={12} lg={8} lgOffset={2}>
          <S.Headline>{headline}</S.Headline>
          <S.Description
            dangerouslySetInnerHTML={{ __html: sanitize(description) }}
          />
        </Col>
      </Row>
      <S.IFrame
        title="Go everlywell.com"
        data-testid="pardot-iframe"
        src="https://go.everlywell.com/l/882283/2021-09-29/24yb4"
        width="100%"
        height="100%"
        scrolling="no"
        className="col-xs-12 col-lg-8 col-lg-offset-2 col"
      />
    </S.Container>
  </SectionWrapper>
);

export default InquirySection;
